import React from 'react';
import {
    ComponentsProps,
    ComponentsOverrides,
    ComponentsVariants,
    Theme,
    autocompleteClasses,
    AutocompleteProps,
    iconButtonClasses,
} from '@mui/material';
import { DownIcon } from '../../components';
import { StyleProps } from './utils/dynamicStyle';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function readOnlyPopupIndicatorStyle(props: StyleProps<AutocompleteProps<any, any, any, any>>) {
    if (props.ownerState?.readOnly) {
        return {
            '&': {
                color: props.theme.palette.action.disabled,
                cursor: 'unset',
            },
            '&:hover': {
                background: 'unset',
                color: props.theme.palette.action.disabled,
            },
        };
    }
    return {};
}

export const MuiAutocomplete: {
    defaultProps?: ComponentsProps['MuiAutocomplete'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiAutocomplete'];
    variants?: ComponentsVariants['MuiAutocomplete'];
} = {
    defaultProps: {
        popupIcon: <DownIcon fontSize="large" />,
        noOptionsText: 'No results found',
    },
    styleOverrides: {
        popupIndicator: (props) => ({
            '&': {
                color: 'inherit',
            },
            ...readOnlyPopupIndicatorStyle(props),
        }),
        endAdornment: {
            top: 0,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
        },
        listbox: (props) => ({
            [`& .${autocompleteClasses.option}`]: {
                padding: props.theme.spacing(props.theme.tokens.spacing.md),
            },
        }),
        noOptions: {
            fontStyle: 'italic',
        },
        option: (props) => ({
            '&::before': {
                content: 'unset',
            },
            ...props.theme.typography.body1,
        }),
    },
};
